/**
 * Beyond Membership Hero Section - JavaScript
 * File: assets/hero-beyond-membership.js
 * Speed-optimized: Viewport-aware lazy video loading, passive listeners, CPU-efficient playback, Flickity slider integration
 */

(function () {
  'use strict';

  window.heroBeyondSliders = window.heroBeyondSliders || {};

  function initHeroBeyondSection(container) {
    if (!container) return;

    const secId = container.dataset.sectionId;
    const trackEl = container.querySelector('#HeroBeyondTrack-' + secId);

    // Destroy existing slider instance if re-initializing (Shopify Customizer)
    if (secId && window.heroBeyondSliders[secId]) {
      try {
        window.heroBeyondSliders[secId].destroy();
      } catch (e) {}
      delete window.heroBeyondSliders[secId];
    }

    const slides = container.querySelectorAll('.hero-beyond__slide');

    // Initialize Flickity if multiple slides exist
    if (trackEl && slides.length > 1) {
      if (typeof Flickity !== 'undefined') {
        const autoplaySetting = trackEl.dataset.autoplay === 'true';
        const autoplaySpeed = parseInt(trackEl.dataset.autoplaySpeed || '6', 10) * 1000;
        const showDots = trackEl.dataset.showDots === 'true';

        const slider = new Flickity(trackEl, {
          cellAlign: 'center',
          contain: true,
          prevNextButtons: false,
          pageDots: showDots,
          autoPlay: autoplaySetting ? autoplaySpeed : false,
          wrapAround: true,
          // We handle hover-pause ourselves for reliability
          pauseAutoPlayOnHover: false,
          selectedAttraction: 0.025,
          friction: 0.28,
          dragThreshold: 3,
          percentPosition: true,
          adaptiveHeight: false
          // imagesLoaded removed: it delays init and races with autoPlay timer
        });

        if (secId) {
          window.heroBeyondSliders[secId] = slider;
        }

        // ---- Reliable autoplay: manual pause/resume ----------------------
        if (autoplaySetting) {
          // Hover pause / resume
          trackEl.addEventListener('mouseenter', function () {
            slider.stopPlayer();
          }, { passive: true });

          trackEl.addEventListener('mouseleave', function () {
            setTimeout(function () { slider.playPlayer(); }, 300);
          }, { passive: true });

          // Touch pause / resume
          trackEl.addEventListener('touchstart', function () {
            slider.stopPlayer();
          }, { passive: true });

          trackEl.addEventListener('touchend', function () {
            setTimeout(function () { slider.playPlayer(); }, 600);
          }, { passive: true });

          // Restart after tab-switch back
          document.addEventListener('visibilitychange', function () {
            if (!document.hidden && window.heroBeyondSliders[secId]) {
              setTimeout(function () {
                window.heroBeyondSliders[secId].playPlayer();
              }, 400);
            }
          });
        }
        // -----------------------------------------------------------------

        // Custom Nav Buttons
        const prevBtn = container.querySelector('[data-prev-id="' + secId + '"]');
        const nextBtn = container.querySelector('[data-next-id="' + secId + '"]');

        if (prevBtn) {
          prevBtn.onclick = function (e) {
            e.preventDefault();
            slider.previous();
            if (autoplaySetting) {
              setTimeout(function () { slider.playPlayer(); }, 500);
            }
          };
        }
        if (nextBtn) {
          nextBtn.onclick = function (e) {
            e.preventDefault();
            slider.next();
            if (autoplaySetting) {
              setTimeout(function () { slider.playPlayer(); }, 500);
            }
          };
        }

        // On slide change, play active video & pause others
        slider.on('change', function (index) {
          handleSlideVideos(container, index);
        });

        // Initial video playback
        handleSlideVideos(container, slider.selectedIndex || 0);
      } else {
        // Retry if Flickity hasn't loaded yet
        setTimeout(function () { initHeroBeyondSection(container); }, 100);
        return;
      }
    } else {
      // Single slide
      handleSlideVideos(container, 0);
    }

    initVideoObserver(container);
    initSmoothScrollButtons(container);
  }

  function handleSlideVideos(container, activeIndex) {
    const slides = container.querySelectorAll('.hero-beyond__slide');
    slides.forEach(function (slide, idx) {
      const videos = slide.querySelectorAll('.hero-beyond__video');
      videos.forEach(function (video) {
        if (idx === activeIndex) {
          if (video.dataset.src && !video.src) {
            video.src = video.dataset.src;
            video.load();
          }
          video.muted = true;
          video.playsInline = true;
          var p = video.play();
          if (p !== undefined) { p.catch(function () {}); }
        } else {
          if (!video.paused) { video.pause(); }
        }
      });
    });
  }

  function initVideoObserver(container) {
    var videos = container.querySelectorAll('.hero-beyond__video');
    if (!videos.length) return;

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          var slide = video.closest('.hero-beyond__slide');
          var isSelected = slide ? slide.classList.contains('is-selected') : true;
          if (entry.isIntersecting && isSelected) {
            if (video.dataset.src && !video.src) {
              video.src = video.dataset.src;
              video.load();
            }
            video.muted = true;
            video.playsInline = true;
            video.play().catch(function () {});
          } else {
            if (!video.paused) { video.pause(); }
          }
        });
      }, { rootMargin: '200px 0px 200px 0px', threshold: 0.05 });

      videos.forEach(function (v) { obs.observe(v); });
    }
  }

  function initSmoothScrollButtons(container) {
    var scrollBtns = container.querySelectorAll('.js-hero-scroll-btn, a[href*="#four-circles-showcase"], [data-scroll-to]');
    scrollBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var targetSelector = btn.getAttribute('data-scroll-to') || btn.getAttribute('href');
        if (targetSelector && targetSelector.indexOf('#') !== -1) {
          var hash = targetSelector.substring(targetSelector.indexOf('#'));
          var targetEl = document.querySelector(hash) || document.getElementById('four-circles-showcase') || document.querySelector('.four-circles-section');
          if (targetEl) {
            e.preventDefault();
            targetEl.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
            // Update URL without jump
            if (history.pushState) {
              history.pushState(null, null, hash);
            }
          }
        }
      });
    });
  }

  // Boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.hero-beyond-section').forEach(initHeroBeyondSection);
    });
  } else {
    document.querySelectorAll('.hero-beyond-section').forEach(initHeroBeyondSection);
  }

  // Shopify Customizer hooks
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.hero-beyond-section') || e.target;
    if (s && s.classList.contains('hero-beyond-section')) { initHeroBeyondSection(s); }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail.sectionId;
    if (id && window.heroBeyondSliders[id]) {
      try { window.heroBeyondSliders[id].destroy(); } catch (ex) {}
      delete window.heroBeyondSliders[id];
    }
  });

  document.addEventListener('shopify:block:select', function (e) {
    var blockId = e.detail.blockId;
    var secId   = e.detail.sectionId;
    if (secId && window.heroBeyondSliders[secId]) {
      var el = e.target.closest('.hero-beyond__slide') || document.querySelector('[data-slide-id="' + blockId + '"]');
      if (el) {
        var idx = Array.from(el.parentNode.children).indexOf(el);
        if (idx >= 0) { window.heroBeyondSliders[secId].select(idx, false, true); }
      }
    }
  });
})();
